import React, { useEffect, useState } from 'react';
import { FormGroup, FormText, Input, ModalBody, ModalHeader } from 'reactstrap';
import Rodal from '../../Rodal/Rodal';
import './RemovalProposalModal.scss';

interface RemovalProposalModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (comment: string) => Promise<boolean>;
}

export const RemovalProposalModal = ({
    isOpen,
    onClose,
    onSubmit,
}: RemovalProposalModalProps) => {
    const [comment, setComment] = useState('');
    const [isTouched, setIsTouched] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setComment('');
            setIsTouched(false);
        }
    }, [isOpen]);

    const isValid = comment.trim().length > 0;

    const submit = async () => {
        if (!isValid) {
            return;
        }
        const succeeded = await onSubmit(comment.trim());
        if (succeeded) {
            onClose();
        }
    };

    return (
        <Rodal
            visible={isOpen}
            onClose={onClose}
            animation="fade"
            showMask={true}
            width={500}
            showCloseButton={true}
            className="ff-removal-modal">
            <ModalHeader>Propose Removal</ModalHeader>
            <ModalBody>
                <p className="ff-removal__description">
                    Add a comment for the other party to review.
                </p>
                <FormGroup>
                    <label
                        className="ff-removal__label"
                        htmlFor="ff-removal-comment">
                        Reason for removal:
                    </label>
                    <Input
                        type="textarea"
                        name="removalComment"
                        id="ff-removal-comment"
                        rows={4}
                        value={comment}
                        onChange={(e: any) => setComment(e.target.value)}
                        onBlur={() => setIsTouched(true)}
                        className={
                            isTouched && !isValid ? 'av-invalid is-invalid' : ''
                        }
                        placeholder="Explain why this item should be removed…"
                    />
                    {isTouched && !isValid && (
                        <FormText color="danger" className="mt-1">
                            A comment is required to propose removal.
                        </FormText>
                    )}
                </FormGroup>
                <div className="buttons-wrapper">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        disabled={!isValid}
                        onClick={submit}>
                        Submit Removal Proposal
                    </button>
                </div>
            </ModalBody>
        </Rodal>
    );
};
